import React, { useEffect, useState } from "react";
import { Container } from "./style";
import {
  BoldLg,
  HorizontalAlign,
  RegLg,
  RegMed,
  RegSm,
  SpaceBetween,
} from "../../../../Components/CustomStyles";
import SmartImage from "../../../../Components/SmartImage";
import dayjs from "dayjs";
import images from "../../../../Constant/images";
import Dropdown from "../../../../Components/DropDownPop";

const CurrentMail = ({ mail, handleDropDown, mailShowingList }) => {
  const [items, setItems] = useState([{ label: "Reply" }, { label: "Delete" }]);
  let currentTab = mailShowingList.find((f) => f.isSelected).id;

  useEffect(() => {
    if (currentTab === 4) {
      setItems([{ label: "Reply" }, { label: "Delete for everyone" }]);
    } else {
      setItems([{ label: "Reply" }, { label: "Delete" }]);
    }
  }, [currentTab]);

  return (
    <>
      {mail?.subject ? (
        <Container>
          <SpaceBetween>
            <BoldLg>{mail?.subject}</BoldLg>
            <Dropdown
              items={items}
              onItemClick={(e) => handleDropDown(e)}
              position={"right"}
              alignment={"left"}
            />
          </SpaceBetween>
          <SpaceBetween style={{ marginTop: 20 }}>
            <HorizontalAlign style={{ alignItems: "flex-start" }}>
              <SmartImage
                src={mail?.sender?.profile_pic ?? images.user}
                style={{ height: 25, width: 25, marginRight: 10 }}
              />
              <BoldLg>{mail?.sender?.first_name ?? ""}</BoldLg>
              <RegLg style={{ marginLeft: 50 }}>
                {mail?.sender?.email ?? ""}
              </RegLg>
            </HorizontalAlign>
            <RegSm>{dayjs(mail?.sent_at).format("MMM DD")}</RegSm>
          </SpaceBetween>
          <div style={{ paddingLeft: 40 }}>
            <RegSm>to me</RegSm>
          </div>
          <div style={{ paddingLeft: 40 }}>
            <RegMed dangerouslySetInnerHTML={{ __html: mail?.body }} />
          </div>
        </Container>
      ) : (
        <></>
      )}
    </>
  );
};

export default CurrentMail;
